import { defineComponent, useModel, ref, watch, openBlock, createElementBlock, createVNode, unref } from 'vue';
import { ElSlider } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                               */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "effect-eq",
  props: {
    "modelValue": { default: "" },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    const values = ref([]);
    function generateValues() {
      const modelValues = model.value.split(" ").filter((emelent) => {
        return emelent.trim().length > 0;
      }).map((emelent) => {
        return parseFloat(emelent);
      });
      values.value = [];
      for (let i = 0; i < 8; i++) {
        values.value.push(modelValues[i] || 0);
      }
    }
    function updateHandler() {
      model.value = values.value.join(" ");
    }
    watch(
      model,
      () => {
        generateValues();
      },
      {
        immediate: true
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { class: "se-effect-eq" }, [
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[0],
          "onUpdate:modelValue": [($event) => values.value[0] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[1],
          "onUpdate:modelValue": [($event) => values.value[1] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[2],
          "onUpdate:modelValue": [($event) => values.value[2] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[3],
          "onUpdate:modelValue": [($event) => values.value[3] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[4],
          "onUpdate:modelValue": [($event) => values.value[4] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[5],
          "onUpdate:modelValue": [($event) => values.value[5] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[6],
          "onUpdate:modelValue": [($event) => values.value[6] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(unref(ElSlider), {
          size: "small",
          modelValue: values.value[7],
          "onUpdate:modelValue": [($event) => values.value[7] = $event, ($event) => updateHandler()],
          min: -20,
          max: 20
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=effect-eq.vue2.js.map
